// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper__1j4Wx","page":"Error_page__2gXJW","icon":"Error_icon__1UpFp","header":"Error_header__s5BvB src_yellow__34kVT","description":"Error_description__2i9f_"};